export default {
      id: "chart-usage",
      viewBox: "0 0 25 25",
      url: __webpack_public_path__ + "img/icons.svg#chart",
      toString: function () {
        return this.url;
      }
    }